import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function buscaGlobal(q, limite = 5) {
  const base = getBase();
  if (!base || !q || q.trim().length < 2) return { q, total: 0, grupos: [] };
  try {
    const res = await axios.get(base + '/busca', {
      headers: getAuthHeaders(), params: { q, limite }, timeout: 20000,
    });
    return res?.data ?? { q, total: 0, grupos: [] };
  } catch (err) {
    return { q, total: 0, grupos: [], erro: err?.response?.data?.error || 'Erro na busca' };
  }
}
